import * as React from 'react';
import { ListPage } from '../../../ui';
import { StudentListFilter, StudentList } from './index';

class StudentListPage extends React.PureComponent {
  render() {
    return (
      <ListPage filter={<StudentListFilter/>}>
        <StudentList/>
      </ListPage>
    );
  }
}

export default StudentListPage;
